const heading = {
  fontFamily: "heading",
  lineHeight: "heading",
  fontWeight: "heading",
  textTransform: "uppercase",
  color: "heading",
}

const theme = {
  breakpoints: ["40em", "66em", "74em"],
  colors: {
    body: "#2F2F2F",
    heading: "#000000",
    background: "#FFFFFF",
    primary: "#1739E6",
    secondary: "#30c",
    muted: "#f6f6f9",
    gray: "#dadada",
    green: "#32BA19",
  },
  fonts: {
    body: "'Montserrat', system-ui, sans-serif",
    heading: "inherit",
    monospace: "Menlo, monospace",
  },
  fontSizes: {
    0: "1rem", // 10px
    1: "1.2rem", // 12px
    2: "1.5rem", // 15px
    3: "1.7rem", // 17px
    4: "1.9rem", // 19px
    5: "2.3rem", // 23px
    6: "2.8rem", // 28px
    7: "3.8rem", // 38px
    8: "4.8rem", // 48px
    9: "7rem", // 70px
    10: "9rem", // 90px
  },
  fontWeights: {
    body: 400,
    heading: 400,
    bold: 600,
    extraBold: 700,
  },
  lineHeights: {
    body: 1.7,
    heading: 1.25,
  },
  space: [0, 5, 10, 15, 25, 40, 80, 120, 200],
  sizes: {
    avatar: 48,
  },
  radii: {
    default: 6,
    card: 19,
    circle: 99999,
  },
  indexes: {
    categorySwitcher: 5,
    header: 6,
    mobileMenu: 7,
  },
  shadows: {
    card: "0 9px 30px rgba(0,0,0,.1)",
    cardSmall: "0 3px 6px rgba(0,0,0,.1)",
    button: "0px 2px 2px rgba(0,0,0,0.1)",
  },
  transitions: {
    hover: "150ms",
  },
  // rebass variants
  text: {
    body: {
      textTransform: "none",
      fontWeight: "body",
    },
    heading: {
      fontFamily: "heading",
      lineHeight: "heading",
      fontWeight: "heading",
    },
    thumbnailTitle: {
      fontSize: [5, 6, 7],
    },
    caps: {
      textTransform: "uppercase",
      letterSpacing: "1px",
      fontWeight: "bold",
      fontSize: 0,
      color: "heading",
    },
  },
  variants: {
    link: {
      color: "primary",
    },
    header: {
      nav: {
        textTransform: "uppercase",
        fontWeight: "bold",
        letterSpacing: "1px",
        fontSize: 0,
      },
    },
  },
  card: {
    p: 2,
    borderRadius: "card",
    bg: "background",
    boxShadow: "card",
  },
  buttons: {
    primary: {
      fontSize: 2,
      fontWeight: "bold",
      color: "background",
      bg: "primary",
      borderRadius: "default",
      "&:focus": {
        boxShadow: "card",
      },
    },
    big: {
      bg: "background",
      fontSize: 1,
      textTransform: "uppercase",
      color: "#000",
      padding: "18px 22px",
      borderRadius: "30px",
      boxShadow: "button",
      "&:focus": {
        outline: "none",
        boxShadow: "card",
      },
    },
    bigPrimary: {
      bg: "primary",
      color: "background",
      fontSize: 1,
      textTransform: "uppercase",
      px: 5,
      py: 3,
      borderRadius: "30px",
      boxShadow: "button",
      "&:hover": {
        bg: "background",
        color: "primary",
      },
      "&:focus": {
        outline: "none",
        boxShadow: "0 0 0 3px #fff, 0 0 0 5px #b8c4ff",
      },
    },
    outline: {
      variant: "buttons.primary",
      color: "primary",
      bg: "transparent",
      boxShadow: "inset 0 0 2px",
    },
    secondary: {
      variant: "buttons.primary",
      color: "primary",
      bg: "background",
    },
    reset: {
      appearance: "none",
      border: "none",
      background: "none",
      p: 0,
    },
    link: {
      variant: "buttons.reset",
      "&:hover": {
        textDecoration: "underline",
      },
    },
  },
  styles: {
    root: {
      h1: {
        ...heading,
        fontWeight: "extraBold",
        fontSize: [8, 10],
      },
      h2: {
        fontWeight: "heading",
        fontSize: [7, 9],
        mb: "1.2em",
      },
      h3: {
        ...heading,
        fontWeight: "heading",
        fontSize: [6, 7],
        mb: "0.9em",
      },
      h4: {
        ...heading,
        fontWeight: "heading",
        fontSize: [3, 4, 6],
        mb: "1.1em",
      },
      h5: {
        ...heading,
        fontSize: 1,
      },
      h6: {
        fontSize: "body",
        fontWeight: "extraBold",
      },
      section: {
        "h1:first-of-type, h2:first-of-type, h3:first-of-type, h4:first-of-type": {
          mt: 0,
        },
        "p ~ h3": {
          mt: 6,
        },
      },
      p: {
        m: 0,
        "& + p": {
          mt: "1.2em",
        },
      },
      a: {
        color: "primary",
        fontWeight: "bold",
        "&:hover": {
          textDecoration: "underline",
        },
      },
    },
    pageWrap: {
      px: [3, 4],
    },
  },
}

theme.space.gridGap = {
  small: theme.space[3],
  large: theme.space[4],
}

theme.space.pageWrap = {
  small: theme.space[3],
  large: theme.space[4],
}

theme.fontSizes.body = theme.fontSizes[2]

export default theme
